// THE money formatter — the only one (Kaizen 2026-08, D9/F3). Five-plus local
// formatters used to render the same value as "$0", "$0.00", or "+0.0037"
// depending on which screen you were on, so when the books drifted the owner
// couldn't tell a data problem from a formatting one. Every dollar figure in
// the app routes through here; per-symbol PRICE precision (FX pips, sub-$10
// crypto) routes through px().

/** Dollars: always ≥2dp, thousands separators; up to 4dp for sub-dollar
 *  values so tiny fractional-share P&L never rounds a scratch to "$0.00". */
export function usd(n: number): string {
  const a = Math.abs(n);
  const maxDp = a > 0 && a < 1 ? 4 : 2;
  return `${n < 0 ? "-" : ""}$${a.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: maxDp,
  })}`;
}

/** Big-tile dollars: whole dollars only (equity, buying power, budgets). */
export function usdCompact(n: number): string {
  return `${n < 0 ? "-" : ""}$${Math.abs(n).toLocaleString("en-US", { maximumFractionDigits: 0 })}`;
}

/** Signed dollars for P&L: the sign is ALWAYS shown, same precision as usd(). */
export function signedUsd(n: number): string {
  const a = Math.abs(n);
  const maxDp = a > 0 && a < 1 ? 4 : 2;
  return `${n < 0 ? "-" : "+"}$${a.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: maxDp,
  })}`;
}

/** Signed percentage, 2dp: "+1.23%" / "-0.45%" / "—" when unknown. */
export function pct(n: number | null | undefined): string {
  if (n == null) return "—";
  return `${n >= 0 ? "+" : ""}${n.toFixed(2)}%`;
}

/** A PRICE, not a dollar amount — per-symbol precision rules. FX pairs
 *  (underscore symbols) quote in the counter currency and move in pips:
 *  rendering 1.40327 as "$1.40" erased entire moves. Crypto has the opposite
 *  problem at the small end of the scale. Consolidated from the three local
 *  px() copies in Performance/TradeStory/NewsSheet. */
export function px(symbol: string, v: number): string {
  return symbol.includes("_") ? v.toFixed(5) : `$${v.toFixed(v < 10 ? 4 : 2)}`;
}
